import { firestore } from "./firebase";
import firebase from './firebase';

const createUserDocument = async (user, additionalData) => {
    if (!user) return null;
    
    const userRef = firestore().doc(`adminUsers/${user.uid}`);
    const snapshot = await userRef.get();
    
    if (!snapshot.exists) {
        const { displayName } = user;
        try {
            await firestore().runTransaction(async transaction => {
                transaction.set(userRef, {
                    displayName,
                    created: firebase.firestore.FieldValue.serverTimestamp(),
                    ...additionalData,
                });
            });
        } catch(error) {
            console.error('Error creating admin user doc. ', error.message);
        }
    } 

    return getUserDocRef(user);
}

const getUserDocRef = async userAuth => {
    
    if (!userAuth.uid) return null;

    // console.log(userAuth.uid);

    try {
        const ref = firestore.collection('adminUsers').doc(userAuth.uid);
        const snapshot = await ref.get();
        if (snapshot.exists) {
            return ref;
        }
    } catch(error) {
        console.error('Error fetching admin user', error.message);
    }

    return null;
}

export { createUserDocument, getUserDocRef };